module.exports = __webpack_public_path__ + "img/ccm-data.0f5a0ccf.svg";